export default __webpack_public_path__ + "static/media/graph2.fa77da71.jpg";